import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { dismissPreBootstrapLoader } from '@infinitform/shared-ui';
import { CspViolationService } from '@infinitform/cabinet-features/services/security/csp-violation.service';
import { AuthService } from '@infinitform/cabinet-features/services/security/auth.service';
import { WebSocketService } from '@infinitform/cabinet-features/services/websocket/websocket.service';
import { WebSocketEventType } from '@infinitform/cabinet-features/services/websocket/websocket.types';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  private cspViolationService = inject(CspViolationService);
  private webSocketService = inject(WebSocketService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  title = 'InfinitForm';

  ngOnInit(): void {
    dismissPreBootstrapLoader();

    this.webSocketService
      .onMessage<{ enabled: boolean; updatedAt?: string | null }>(WebSocketEventType.MAINTENANCE_STATUS)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((message) => {
        if (this.authService.isAdmin) {
          return;
        }
        if (message?.data?.enabled === true) {
          if (this.router.url !== '/maintenance') {
            this.router.navigate(['/maintenance']);
          }
          return;
        }
        if (message?.data?.enabled === false) {
          if (this.router.url !== '/user/projects') {
            this.router.navigate(['/user/projects']);
          }
        }
      });
  }


  ngOnDestroy(): void {
    this.webSocketService.disconnect();
  }
}
